/** Canonical tool metadata owned by code, not translation files. */
export const TOOL_DEFINITIONS = [
  { id: 'voice', slug: 'free-tts', accent: '#1E40AF', accentBg: '#DBEAFE' },
  { id: 'image', slug: 'free-image', accent: '#5323D3', accentBg: '#F4EEFF' },
  {
    id: 'background-remover',
    slug: 'free-background-remover',
    accent: '#166534',
    accentBg: '#DCFCE7',
  },
  { id: 'upscaler', slug: 'free-upscaler', accent: '#9D174D', accentBg: '#FCE7F3' },
] as const

export type ToolDefinition = (typeof TOOL_DEFINITIONS)[number]
export type ToolId = ToolDefinition['id']
export type ToolSlug = ToolDefinition['slug']

export const TOOL_IDS = TOOL_DEFINITIONS.map(tool => tool.id) as [ToolId, ...ToolId[]]
export const TOOL_SLUGS = TOOL_DEFINITIONS.map(tool => tool.slug) as [ToolSlug, ...ToolSlug[]]

export const toolDefinitionsById = Object.fromEntries(
  TOOL_DEFINITIONS.map(tool => [tool.id, tool]),
) as Record<ToolId, ToolDefinition>

export const toolDefinitionsBySlug = Object.fromEntries(
  TOOL_DEFINITIONS.map(tool => [tool.slug, tool]),
) as Record<ToolSlug, ToolDefinition>
